// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0efa4e37","732":"734bcefe","977":"39f5d4f3"}[chunkId] + ".chunk.js";
};